import { render, staticRenderFns } from "./ManageFlow.vue?vue&type=template&id=0aa81a8c&scoped=true&"
import script from "./ManageFlow.vue?vue&type=script&lang=js&"
export * from "./ManageFlow.vue?vue&type=script&lang=js&"
import style0 from "./ManageFlow.vue?vue&type=style&index=0&id=0aa81a8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa81a8c",
  null
  
)

export default component.exports